import { useCallCallback } from './useCallCallback';
import { useCallAnimation } from './useCallAnimation';
import { useCallModal } from './useCallModal';
import { useCallDisposable } from './useDisposable';
import { useCallEventsCallbacks } from './useCallEventsCallbacks';
import useIsNew from './useIsNewFlag';
import useCallIsNewFlag from './useCallIsNewFlag';
import useCallGtm from './useCallGtm';
import { isFunction } from 'lodash';
import useCallRedirect from './useCallRedirect';
import useCallLink from './useCallLink';
import useCallSound from './useCallSound';

export const useButtonControls = ({
  onClick: click,

  isDisposable = false,
  timeout = 300,

  preventDefault,
  stopPropagation,

  sound,

  customCallbacks,
  callbackKey,
  callbackOptions,

  modalData,

  clickAnimation,

  newFlagData,

  redirect,

  gtm,
  gtmProps,

  link,
}) => {
  const isNewFlag = useIsNew({ newFlagData });

  const { callCallback } = useCallCallback({ callbackKey, callbackOptions, customCallbacks });
  const { callAnimation, onAnimationEnd, classes } = useCallAnimation({ clickAnimation });
  const { callModal } = useCallModal({ modalData });
  const { callDisposable } = useCallDisposable({ isDisposable, timeout });
  const { callEventsCallbacks } = useCallEventsCallbacks({ preventDefault, stopPropagation });
  const { callIsNewFlag } = useCallIsNewFlag({ newFlagData, isNewFlag });
  const { callGtm } = useCallGtm({ gtm, gtmProps });
  const { callRedirect } = useCallRedirect({ redirect });
  const { callLink } = useCallLink({ link });
  const { callSound } = useCallSound({ sound });

  const onClick = (e) => {
    const isCanClick = callDisposable();

    if (!isCanClick) return;

    callEventsCallbacks(e);
    callCallback();
    callModal();
    callAnimation();
    callIsNewFlag();
    callGtm();
    callRedirect();
    callLink();
    callSound();

    isFunction(click) && click(e);
  };

  return { onClick, isNewFlag, onAnimationEnd, classes };
};
